<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content [formGroup]="reasonForm">
    <div [innerHTML]="message"></div>
    @if (needReason) {
      <mat-form-field  appearance="outline" class="w-100 mt-3">
        <mat-label>Reason</mat-label>
        <input matInput formControlName="reason" required>
        @if (reasonForm.controls.reason.errors?.required) {
          <mat-error>Reason is required</mat-error>
        }
        @if (reasonForm.controls.reason.hasError('minlength')) {
          <mat-error>Reason isn't long enough, minimum of 5 characters</mat-error>
        }
      </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 my-3">
      <button mat-flat-button class="w-49" color="primary" (click)="onConfirmClick()" tabindex="1" [disabled]="!canConfirm">{{confirmButtonText}}</button>
      <button mat-flat-button class="w-49" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>

